<template>
    <div class="alert alert-warning" role="alert">
        <font-awesome-icon :icon="['fas', 'exclamation-triangle']" /> {{msgAdvertencia}}
    </div>
</template>
<script>
    export default {
        props: ['msgAdvertencia']
    }
</script>